import { Disclosure } from "@headlessui/react";
import { MenuIcon, XIcon } from "@heroicons/react/outline";
import style from "./hamburger_menu.module.css";
import { Fragment, useRef, useState, useEffect } from "react"
import Link from "next/link";

export default function HamburgerMenu({
  onMobileNavOpenModal: parentOnDropLeadModalOpenHandler
}) {
  let menuBtnRef = useRef(null)
  // const [menuBtnRefEventAdded, setMenuBtnRefEventAdded] = useState(false)
  const navigation = [
    { name: "หน้าหลัก", href: "/", current: true },
    { name: "แผนประกันบ้าน", href: "/products", current: false },
    { name: "คำนวณเบี้ยประกัน", href: "/calculate-plan/home-info", current: false },
    { name: "ประกันบ้านสำหรับ SME", href: "/smes", current: false },
    { name: "เรื่องบ้านน่ารู้", href: "/articles", current: false },
    { name: "คำถามที่พบบ่อย", href: "/faq", current: false},
    // { name: "เกี่ยบกับเรา", href: "#", current: false },
    // { name: "ติดต่อเรา", href: "#", current: false },
    
  ];
  function classNames(...classes) {
    return classes.join(" ");
  }

  const onDropLeadModalOpenHandler = (e) => {
    parentOnDropLeadModalOpenHandler(e)
  }

  /* this group of function will be used for new nav hamburger menu */
  // /* toggling overflow state to body */
  // const onMenuOpenClickHandler = (e) => {
  //   const body = document.body
  //   const documentBodyOverflowToggler = (body) => {
  //     const menuOpened = body.classList.contains('menu_opened')
  //     menuOpened ? body.classList.remove('menu_opened') : body.classList.add('menu_opened')
  //   }

  //   documentBodyOverflowToggler(body)
  // }

  // useEffect(() => {
  //   if(!menuBtnRef) return;
  //   if(menuBtnRefEventAdded) return;
  //   menuBtnRef.addEventListener('click', onMenuOpenClickHandler)
  //   setMenuBtnRefEventAdded(true)
  // })

  return (
    <Disclosure as="div" className={style.hamburger_menu}>
      {({ open }) => (
        <>
          <div className={style.hamburger_menu_container}>
            <Disclosure.Button className={style.hamburger_menu_btn} ref={(ref) => (menuBtnRef = ref)}>
              <span className="sr-only">Open main menu</span>
              {open ? (
                <XIcon className="block" />
              ) : (
                <MenuIcon className="block" />
              )}
            </Disclosure.Button>
            <div className={style.highlighted_nav}>
            {!open && (
                <ul>
                  <li key="home">
                    <Link href="/">
                      <a>หน้าหลัก</a>
                    </Link>
                  </li>
                  <li key="products">
                    <Link href="/products">
                      <a>แผนประกัน</a>
                    </Link>
                  </li>
                  <li key="calculatePlan">
                    <Link href="/calculate-plan/home-info">
                      <a>คำนวณเบี้ย</a>
                    </Link>
                  </li>
                </ul>
              )}
              {open && (
                <div className={style.all_navs}>
                  <p>เมนูทั้งหมด</p>
                </div>
              )}
            </div>
          </div>
            <Disclosure.Panel className={style.panel}>
              <div className={style.nav_panel_wrapper}>
                {navigation.map((item, index) => (
                  <Fragment key={index}>
                    <Disclosure.Button className={classNames(style.nav)}>
                      <Link href={item.href}>
                        <a>{item.name}</a>
                      </Link>
                    </Disclosure.Button>
                  </Fragment>
                ))}
              </div>
            </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
